export const FESTIVAL_BANNER_IMAGE = "https://media.cars24.com/au/prod/desktop/sale-assets/deskto-main-banner.webp";
export const FESTIVAL_BANNER_TEXT_IMAGE = "https://media.cars24.com/au/prod/desktop/sale-assets/desktop-text-banner.webp";
